module.exports = __webpack_public_path__ + "img/Feature.07f709f6.png";